import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Table } from 'reactstrap';
import withLoader from 'components/organisms/withLoader';
import ResetPasswordModal from 'components/organisms/resetPassword';
import AgencyDoctorRow from './components/agencyDoctorRow';
import AgencyDoctorsHeader from './components/header';
import AgencyDoctorsFooter from './components/footer';
import AgencyDoctorsToolbar from './components/toolbar';

const AdminPanelAgencyDoctors = () => {
  const [email, setEmail] = useState(null);
  const [resetPasswordPopupOpen, setResetPasswordPopupOpen] = useState(false);
  const { data } = useSelector((state) => state.adminPanelAgencyDoctors);

  const { getAgencyDoctors: agencyDoctorsLoading } = useSelector(
    (state) => state.loading.effects.adminPanelAgencyDoctors,
  );

  return (
    <div className="adminPanel">
      <Card className="card-border">
        <CardBody className="card-outer">
          <AgencyDoctorsHeader />
          <AgencyDoctorsToolbar />
          <div className="adminPanel__table">
            {withLoader(
              agencyDoctorsLoading,
              <Table bordered cellSpacing="0">
                <thead>
                  <tr>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Full Name
                      </div>
                    </th>

                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Role
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Agency
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Email
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Reset Email
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Status
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="adminPanel-agencyDoctors">
                  {data.map((agencyDoctor, index) => (
                    <AgencyDoctorRow
                      key={`${agencyDoctor.guid}-${index}`}
                      data={agencyDoctor}
                      selectEmail={() => {
                        setEmail(agencyDoctor.email);
                        setResetPasswordPopupOpen(true);
                      }}
                    />
                  ))}
                </tbody>
              </Table>,
            )}
          </div>
          <AgencyDoctorsFooter />
        </CardBody>
      </Card>
      <ResetPasswordModal
        isOpen={resetPasswordPopupOpen}
        toggle={setResetPasswordPopupOpen}
        email={email}
      />
    </div>
  );
};

export default AdminPanelAgencyDoctors;
